export default __webpack_public_path__ + "static/media/AcuteCareatHomeSHSCTv8220518SouthHSCTAcuteCareatHomereferralguidelinev8_flowchart.98f89a6a.jpg";